import RestService from '../services/rest';

async function getAdminUsers() {
  return RestService.getAuthenticated('panel/admins');
}

async function updateAdminUser(id, {
  name, email, password, profileId,
}) {
  return RestService.postAuthenticated(`panel/admins/update?id=${id}`, {
    name, email, password, profileId,
  });
}

async function activeAdminUser(id, status) {
  return RestService.postAuthenticated(`panel/admins/update?id=${id}`, { status });
}

// eslint-disable-next-line object-curly-newline
async function createAdminUser({ name, email, password, profileId }) {
  // eslint-disable-next-line object-curly-newline
  return RestService.postAuthenticated('panel/admins/create', { name, email, password, profileId });
}

async function getCsvAdminUsersModel() {
  const response = await RestService.getAuthenticated('panel/admins/csv/model', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Modelo_Importação_AdminUsers CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvAdminUsers(file) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated('panel/admins/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

export default {
  getAdminUsers,
  updateAdminUser,
  createAdminUser,
  activeAdminUser,
  getCsvAdminUsersModel,
  uploadCsvAdminUsers,
};
